export * from '@kaidam/fc-shared/src/frontend/store/selectors/router'
import defaultSelectors from '@kaidam/fc-shared/src/frontend/store/selectors/router'
export default defaultSelectors